<script setup>
import Icon from "./IconBase.vue";
</script>

<template>
    <Icon class="rotate-90">
        <path
            class="path1"
            d="M793.6 1024h-614.4c-42.347 0-76.8-34.453-76.8-76.8v-512c0-42.347 34.453-76.8 76.8-76.8h204.8c14.138 0 25.6 11.462 25.6 25.6s-11.462 25.6-25.6 25.6h-204.8c-14.115 0-25.6 11.485-25.6 25.6v512c0 14.115 11.485 25.6 25.6 25.6h614.4c14.115 0 25.6-11.485 25.6-25.6v-512c0-14.115-11.485-25.6-25.6-25.6h-204.8c-14.139 0-25.6-11.462-25.6-25.6s11.461-25.6 25.6-25.6h204.8c42.347 0 76.8 34.453 76.8 76.8v512c0 42.347-34.453 76.8-76.8 76.8z"
        >
        </path>
        <path
            class="path2"
            d="M658.099 186.699l-153.6-153.6c-9.997-9.998-26.206-9.998-36.203 0l-153.6 153.6c-9.998 9.997-9.998 26.206 0 36.203s26.206 9.998 36.203 0l109.901-109.899v578.197c0 14.139 11.462 25.6 25.6 25.6s25.6-11.461 25.6-25.6v-578.197l109.901 109.898c4.997 5 11.547 7.499 18.099 7.499s13.102-2.499 18.099-7.499c10-9.997 10-26.205 0-36.202z"
        >
        </path>
    </Icon>
</template>
